var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatinha01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 37.2",
    style: {
      enableBackground: "new 0 0 36 37.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.9,33.7c-1.4-0.3-2.4-1-3-2.3c-0.3-0.6-0.4-1.2-0.5-1.8c-0.2-0.9-0.2-1.9,0.1-2.8c0.3-1,0.8-1.8,1.5-2.5 c0.9-1,1.9-1.9,2.7-3c0.6-0.8,1-1.6,1.5-2.4c0.5-0.8,1.1-1.6,1.9-2.2c1.8-1.3,3.8-1.3,5.5,0.2c0.9,0.7,1.5,1.6,2,2.6 c0.8,1.4,1.8,2.6,2.9,3.7c0.5,0.5,1.1,1.1,1.6,1.7c0.9,1.1,1.1,2.5,1,3.8c-0.1,1-0.3,1.9-0.8,2.8c-0.8,1.4-2.4,2.2-4.1,2 c-1.3-0.2-2.5-0.5-3.7-0.9c-0.4-0.1-0.8-0.2-1.1-0.3c-1-0.1-1.9,0.1-2.8,0.4c-0.9,0.3-1.8,0.6-2.8,0.8c-0.1,0-0.3,0-0.5,0.1 C11.8,33.7,11.4,33.7,10.9,33.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.7,8.1c-0.1,2-0.7,3.8-2.3,5.2c-0.8,0.8-1.8,1.2-3,1c-1.1-0.2-1.9-1-2.3-2c-0.7-1.7-0.6-3.4,0-5.1 c0.4-1.2,1.1-2.2,2.1-2.9C22.1,3.9,23,3.5,24,3.8c1.2,0.3,1.9,1.2,2.3,2.3C26.6,6.7,26.7,7.4,26.7,8.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.1,8.6c0-1.4,0.3-2.7,1.2-3.8c1.4-1.6,3.4-1.7,4.8-0.1c0.9,1,1.4,2.1,1.5,3.4c0.2,1.5,0,2.9-0.7,4.3 c-0.6,1-1.3,1.7-2.5,1.9c-0.9,0.1-1.6-0.1-2.3-0.7c-1.1-0.8-1.6-2-1.9-3.3C9.1,9.7,9.1,9.1,9.1,8.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,15.7c0-0.9,0.2-1.7,0.5-2.4c0.8-1.5,2.4-1.9,3.9-1.1c1,0.6,1.7,1.5,2.1,2.6c0.5,1.3,0.7,2.7,0.2,4.1 c-0.4,1.1-1.1,1.9-2.3,2.1c-0.6,0.1-1.2-0.1-1.8-0.4c-1.3-0.8-2-2-2.4-3.5C3.1,16.7,3,16.2,3,15.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33,15.7c0,1.6-0.6,3.1-1.7,4.3c-0.4,0.4-0.8,0.7-1.4,0.9c-1.2,0.5-2.4,0.1-3.1-0.9c-0.6-0.8-0.8-1.8-0.8-2.7 c0-1.5,0.5-2.9,1.5-4.1c0.6-0.7,1.3-1.2,2.3-1.3c1.2-0.1,2.1,0.4,2.6,1.5C32.9,14,33,14.8,33,15.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatinha01);
export default __webpack_public_path__ + "static/media/patinha-01.25941cc192123bdee2be7720a5a771ed.svg";
export { ForwardRef as ReactComponent };